import * as React from 'react';
import { AppSettings, ScrollToTop, SecuredApplication, configureAxios } from '@konicaminolta/common-react';
import { history, persistor, store, userManager } from '../../store/configureStore';
import { appSettings } from '../../appSettings';
import { History, LocationState } from 'history';
import { UserManager } from 'oidc-client';
import NavMenuSharableLink from './NavMenuSharableLink';

type SecuredApplicationProps = {
    appSettings: AppSettings;
    userManager: UserManager;
    history: History<LocationState>;
}

class SecuredApplicationPreloader extends React.Component<SecuredApplicationProps> {

    public constructor(props: SecuredApplicationProps) {
        super(props);
    }

    public componentDidMount() {
    }

    runAfterRender = () =>
    {
        // Change this to find all siblings and hide or hide all but only show my stuff
        // If we are showing the custom nav, we are hiding the rest
        var showCustomNav = window.location.pathname.includes("/viewreport/") || window.location.pathname.includes("/viewdashboard/");
        if (showCustomNav) {
            var element = document.querySelector('header');
            if (element) {
                element.style.display = 'none';
            }
            element = document.querySelector('[aria-label="breadcrumb"]');
            if (element) {
                element.style.display = 'none';
            }
        }
    }

    public render() {
        this.runAfterRender()
        return (
            <div onLoad={this.runAfterRender}>
                <SecuredApplication
                    appSettings={appSettings}
                    userManager={userManager}
                    history={history}
                />
            </div>
        )
    }
}
  
export default (SecuredApplicationPreloader);